import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { DirezioneTerritorialeLavoro } from '../../../../common/models/tipologiche/direzione-territoriale-lavoro';

export class FascicoloTentativoObbligatorioConciliazione extends FascicoloFull {
  direzioneTerritoriale: DirezioneTerritorialeLavoro;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
